import { Permission, UserRole } from './roles.const'

export const tabs = {
  dashboard: [
    {
      name: 'Operational Statistics',
      link: '/dashboard',
      role: [UserRole.ADMIN]
    }
  ],
  'license-key-list': [
    {
      name: 'License Keys',
      link: '/license-key-list',
      role: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Clinics',
      link: '/clinic-list',
      role: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Package Templates',
      link: '/license-package-template',
      role: [UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Audit Logs',
      link: '/audit-logs',
      role: [UserRole.ADMIN]
    },
    {
      name: '3D Segmentation licenses',
      link: '/eai-licenses',
      role: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN],
      permissions: [Permission.EAI_LICENSES]
    }
  ],
  'release-list': [
    {
      name: 'Product',
      link: '/product',
      role: [UserRole.ADMIN],
      permissions: [Permission.PRODUCT_PERMISSION]
    },
    {
      name: 'Release List',
      link: '/release-list',
      role: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Release Note',
      link: '/release-note',
      role: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Notification',
      link: '/notification',
      role: [UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Auto-Download',
      link: '/auto-download-management',
      role: [UserRole.ES, UserRole.ADMIN]
    }
  ],
  'sales-area-management': [
    {
      name: 'Sales-Area',
      link: '/sales-area-management',
      role: [UserRole.ES, UserRole.ADMIN]
    },
    {
      name: 'Locale Setting',
      link: '/locale-setting',
      role: [UserRole.ES, UserRole.ADMIN]
    }
  ],
  'user-management': [
    {
      name: 'Users Management',
      link: '/user-management',
      role: [UserRole.ADMIN]
    }
  ]
}

export const headers = {
  'user-management': tabs['user-management'],
  dashboard: tabs['dashboard'],
  'license-key-list': tabs['license-key-list'],
  'license-package-template': tabs['license-key-list'],
  'clinic-list': tabs['license-key-list'],
  'eai-licenses': tabs['license-key-list'],
  product: tabs['release-list'],
  'release-list': tabs['release-list'],
  'release-note': tabs['release-list'],
  notification: tabs['release-list'],
  'auto-download-management': tabs['release-list'],
  'sales-area-management': tabs['sales-area-management'],
  'locale-setting': tabs['sales-area-management'],
  'audit-logs': tabs['license-key-list']
}
